
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class ModalFullScreen extends Vue {


    @Prop({ type: String, default: "gray"}) readonly color!: string;

get getColors(){

switch (this.color) {
  case 'gray':
    return {fill: 'transparent', pathFill: '#9fa6b2'}


    default:
      return {fill: '#1A7BEE', pathFill: '#ffffff'}
}
}


  }


  